import { Dictionary } from "@networx/utils/types/Dictionary";
import { global } from "@/utils/window";

export function getAuthHeaders() {
  const headers: Dictionary = {};
  if (hasHomeownerToken()) {
    headers['X-NX-HOMEOWNER-AUTHORIZATION'] = `Bearer ${global.homeowner_token}`;
  }
  if (hasAdminToken()) {
    headers['X-NX-ADMIN-AUTHORIZATION'] = `Bearer ${global.admin_token}`;
  }
  return headers;
}

function hasHomeownerToken() {
  return global.homeowner_token !== undefined;
}

function hasAdminToken() {
  return global.admin_token !== undefined;
}

